import React from 'react'
import TrackingContent from './trackingContent'

class Tracking extends React.Component {
    render() {
        return (
            <TrackingContent
                history={this.props.history}
                orderId={this.props.location.state.orderId}
            />
        )
    }
}

export default Tracking
